module.exports = __webpack_public_path__ + "c44138d0b27cd3f5d8ded1efc0d5db2b.png";